module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-oee-ui-desktop.en-af0155310c36e89b922b9cc06ec83743.png";